<template>
    <AlternativeHeader />

    <!-- Header Image Start -->
    <div class="container-fluid d-flex justify-content-center my-5">
        <img
            src="/img/landing_page/new_download_app_banner@2x.webp"
            class="img-fluid mx-h-500 max-h-90vh w-100 d-md-block d-none"
            alt="Euro Petrol Klub lojalnosti za ficička i pravna lica, agro i taksi preduzeća"
        />
        <img
            src="/img/landing_page/new_download_app_mobile_banner.webp"
            srcset="/img/landing_page/new_download_app_mobile_banner@2x.webp 2x"
            class="img-fluid w-100 d-md-none d-block"
            alt="Euro Petrol Klub lojalnosti za ficička i pravna lica, agro i taksi preduzeća"
        />
    </div>
    <!-- Header Image End -->

    <!-- First title section -->
    <div class="container title-section text-center d-flex flex-column align-items-center mb-4">
        <h1 class="section-title text-main">Učlanite se u Euro Petrol Klub</h1>
        <p class="section-subtitle text-center w-75 mt-2">Postanite član Euro Petrol Kluba, brzo i jednostavno.</p>
        <div class="text-start w-100 pt-4 pb-2">
            <b>Euro Petrol Klub lojalnosti pruža brojne pogodnosti fizičkim i pravnim licima, poljoprivrednim i taksi preduzećima!</b>
            <p>Članstvo je besplatno, učlanjenje brzo i jednostavno instaliranjem mobilne aplikacije ili kreiranjem odgovarajuće klub kartice na našim benzinskim stanicama.</p>
        </div>
    </div>
    <!-- First title section end -->

    <!-- Main container -->
    <section id="privay-policy" class="container pt-2 pb-5">
        <ul class="nav nav-tabs" id="epk-switcher" role="tablist">
            <li class="nav-item" role="presentation">
                <button class="nav-link text-dark active" id="fizicka-lica-tab" ref="fizicka-lica" data-bs-toggle="tab" data-bs-target="#fizicka-lica" type="button" role="tab" aria-controls="fizicka-lica" aria-selected="true">Fizička lica</button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link text-dark" id="poljoprivrednici-tab" ref="poljoprivrednici" data-bs-toggle="tab" data-bs-target="#poljoprivrednici" type="button" role="tab" aria-controls="poljoprivrednici" aria-selected="false">Poljoprivrednici</button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link text-dark" id="taksisti-tab" ref="taksisti" data-bs-toggle="tab" data-bs-target="#taksisti" type="button" role="tab" aria-controls="taksisti" aria-selected="false">Taksisti</button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link text-dark" id="pravna-lica-tab" ref="pravna-lica" data-bs-toggle="tab" data-bs-target="#pravna-lica" type="button" role="tab" aria-controls="pravna-lica" aria-selected="false">Pravna lica</button>
            </li>
        </ul>
        <div class="tab-content" id="myTabContent">
            <!-- Fizicka lica -->
            <div class="tab-pane fade p-4 show active" id="fizicka-lica" role="tabpanel" aria-labelledby="fizicka-lica-tab">
                <div class="row mb-3">
                    <img
                        class="img-fluid col-xl-2 col-lg-3 col-md-4 col-6"
                        src="/img/epk/epk_card_1.webp"
                        srcset="
                            /img/epk/epk_card_1@2x.webp 2x,
                            /img/epk/epk_card_1@3x.webp 3x
                        "
                        alt="Kartica za fizičko lice"
                    />
                    <img
                        class="img-fluid col-xl-2 col-lg-3 col-md-4 col-6"
                        src="/img/epk/qr_code.webp"
                        srcset="
                            /img/epk/qr_code@2x.webp 2x,
                            /img/epk/qr_code@3x.webp 3x
                        "
                        alt="Telefon QR kod"
                    />
                </div>
                <h3 class="fw-bold mb-3 color-main">Šta obezbeđuje mobilna aplikacija za fizička lica?</h3>
                <ul>
                    <li class="mb-3">
                        <p class="mb-2">
                            <b>Uštedu po litri</b> pri svakom tankovanju:
                        </p>
                        <ul>
                            <li class="mb-2">Auto gas TNG: 2 rsd/litar</li>
                            <li class="mb-2">Evro premijum BMB 95: 2 rsd/litar</li>
                            <li class="mb-2">Evro dizel: 2 rsd/litar</li>
                            <li class="mb-2">Lion Expert BMB 100: 10 rsd/litar</li>
                            <li class="mb-2">Lion Expert dizel: 10 rsd/litar</li>
                        </ul>
                    </li>

                    <li class="mb-3">
                        Popuste na <b>auto kozmetiku, ručno i mašinsko pranje, usisavanje, kao i na propan butan gas u punjenju od 5, 10, 35 kg</b>
                    </li>

                    <li class="mb-3">
                        <b>Popust 10%</b> na kompletan asortiman Lion Expert robne marke
                    </li>

                    <li class="mb-3">
                        Informacije o <b>akcijama</b> i <b>specijalnim ponudama</b>
                    </li>

                    <li class="mb-4">
                        <b>Evidenciju potrošnje</b>, <b>pregled ušteda</b>, mapa Euro Petrol benzinskih stanica
                    </li>
                </ul>

                <div class="col-lg-12 mt-3 mb-5">
                    <button class="btn btn-secondary lh-lg rounded-0 d-flex align-items-center gap-1" type="submit"  @click="isOpen = !isOpen;"> Detaljnije informacije o popustima <i class="ri-download-line color-main"></i></button>
                    <transition name="modal-custom">
                    <div v-if="isOpen">
                        <div class="overlay-modal" @click.self="isOpen = false;">
                            <div class="modal-custom">
                                <img src="../assets/media/epk-popust-oct-2026.webp" class="img-fluid" alt="Informacije o Euro Petrol Klub popustima">
                            </div>
                        </div>
                    </div>
                    </transition>
                </div>

                <h3 class="fw-bold mb-3 color-main">Kako do aplikacije?</h3>
                <p>
                    Učlani se u klub lojalnosti instaliranjem <b>Euro Petrol aplikacije</b> za samo nekoliko minuta.
                    Članstvo je potpuno besplatno i bezuslovno.
                </p>

                <div class="container pb-5 pt-3">
                    <div class="d-inline-flex gap-3 py-3 flex-wrap justify-content-center">
                        <a href="https://apps.apple.com/us/app/euro-petrol/id1459216332" target="_blank" rel="noopener" class="btn bg-black-20 px-4 py-3">
                            <img src="../assets/media/app-store-btn.svg" alt="App store">
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.europetrol.epk" target="_blank" rel="noopener" class="btn bg-black-20 px-4 py-3">
                            <img src="../assets/media/play-store-btn.svg" alt="Play Store">
                        </a>
                        <a href="https://appgallery.huawei.com/app/C104584461" target="_blank" rel="noopener" class="btn bg-black-20 px-4 py-3">
                            <img src="../assets/media/app-gallery-btn.svg" alt="App Gallery">
                        </a>
                    </div>
                </div>

                <h3 class="fw-bold mb-3 color-main">Ko može postati korisnik mobilne aplikacije/kartice?</h3>

                <p class="mb-5">
                    Svi zadovoljni kupci koji žele ostvariti benefite kluba lojalnosti! Euro Petrol ceni verne i lojalne kupce i nagrađuje značajnim popustima!
                </p>

                <h3 class="fw-bold mb-3 color-main">Da li se aplikacija naplaćuje?</h3>

                <p class="mb-5">
                    Euro Petrol Klub kartica i Euro Petrol aplikacija za fizička lica su potpuno besplatne, služe kao sredstvo za ostvarivanje prava na popust!
                </p>
            </div>
            <!-- Poljoprivrednici -->
            <div class="tab-pane fade p-4" id="poljoprivrednici" role="tabpanel" aria-labelledby="poljoprivrednici-tab">
                <img
                    class="img-fluid col-xl-2 col-lg-3 col-md-4 col-6"
                    src="/img/epk/epk_card_2.webp"
                    srcset="
                        /img/epk/epk_card_2@2x.webp 2x,
                        /img/epk/epk_card_2@3x.webp 3x
                    "
                    alt="Kartica za poljoprivrednici"
                />
                <h3 class="fw-bold my-3 color-main">Šta obezbeđuje Agro kartica?</h3>

                <ul>
                    <li class="mb-3">
                        <p class="mb-2">
                            <b>Agro kartica obezbeđuje popuste na sve vrste goriva:</b>
                        </p>
                        <ul>
                            <li class="mb-2">Auto gas TNG: 2 rsd/litar</li>
                            <li class="mb-2">Evro premijum BMB 95: 2 rsd/litar</li>
                            <li class="mb-2">Lion Expert BMB 100: 10 rsd/litar</li>
                            <li class="mb-2">Lion Expert dizel: 10 rsd/litar</li>
                            <li class="mb-2">Evro dizel: 3 rsd/litar</li>
                        </ul>
                    </li>

                    <li class="mb-3">
                        <b>Stabilnu uštedu na gorivo</b> za svaku sezonu
                    </li>

                    <li class="mb-4">
                        Popuste na <b>auto kozmetiku, ručno i mašinsko pranje, usisavanje kao i na propan butan gas u punjenju od 5, 10, 35 kg</b>
                    </li>
                </ul>

                <h3 class="fw-bold mb-3 color-main">Kako do Agro kartice?</h3>

                <p>Pripremiti i dostaviti <b>potrebnu dokumentaciju</b>:</p>

                <ul>
                    <li class="mb-2">Kopiju lične karte</li>
                    <li class="mb-2">Kontakt telefon</li>
                </ul>

                <p class="mb-3">
                    Poslati potrebnu dokumentaciju na adresu: Euro Petrol doo, Senćanski put 75, 24000 Subotica, ili predati dokumentaciju na bilo kojoj Euro Petrol benzinskoj stanici.
                </p>

                <p class="mb-5">
                    Nije moguće online podnošenje zahteva za izradu Agro kartice.
                </p>

                <h3 class="fw-bold mb-3 color-main">Ko može postati korisnik Agro kartice:</h3>

                <p class="mb-5">
                    Punoletna osoba koja obavlja <b>poljoprivrednu proizvodnju</b>.
                </p>

                <h3 class="fw-bold mb-3 color-main">Za koliko dana stiže Agro kartica?</h3>

                <p class="mb-5">
                    Kartica stiže najkasnije u roku od <b>5 radnih dana</b> na adresu koju navedete ili na izabranu Euro Petrol stanicu.
                </p>

                <h3 class="fw-bold mb-3 color-main">Da li se Agro kartica naplaćuje?</h3>

                <p class="mb-5">
                    Kartica je <b>besplatna</b> i služi kao sredstvo za ostvarivanje popusta.
                </p>
            </div>
            <!-- Taksisti -->
            <div class="tab-pane fade p-4" id="taksisti" role="tabpanel" aria-labelledby="taksisti-tab">
                <img
                    class="img-fluid col-xl-2 col-lg-3 col-md-4 col-6"
                    src="/img/epk/epk_card_3.webp"
                    srcset="
                        /img/epk/epk_card_3@2x.webp 2x,
                        /img/epk/epk_card_3@3x.webp 3x
                    "
                    alt="Kartica za taksiste"
                />

                <h3 class="fw-bold my-3 color-main">Šta obezbeđuje Taksi kartica?</h3>

                <p class="mb-2">Posebne uštede za profesionalne vozače! Popusti po litru:</p>

                <ul class="mb-5">
                    <li class="mb-2">Auto gas TNG: 3 rsd/litar</li>
                    <li class="mb-2">Evro premijum BMB 95: 3 rsd/litar</li>
                    <li class="mb-2">Lion Expert BMB 100: 10 rsd/litar</li>
                    <li class="mb-2">Lion Expert dizel: 10 rsd/litar</li>
                    <li class="mb-2">Evro dizel: 3 rsd/litar</li>
                </ul>

                <h3 class="fw-bold mb-3 color-main">Kako do Taksi kartice?</h3>

                <p>Do Taksi kartice u samo 4 koraka.</p>

                <p>Potrebno je da:</p>
                <ul>
                    <li class="mb-3">
                        <p class="mb-2">
                            <b>Prikupite</b> potrebnu dokumentaciju
                        </p>
                        <ul>
                            <li class="mb-2">Kopija lične karte.</li>
                            <li class="mb-2">Potvrda o aktivnom statusu u Registru privrednih subjekata.</li>
                            <li class="mb-2">Fotokopija saobraćajne dozvole.</li>
                        </ul>
                    </li>

                    <li class="mb-3">
                        <b>Preuzmete pristupnicu</b>
                        na benzinskoj stanici ili je preuzmite sa sajta
                        (<a target="_blank" class="color-main" href="./forms/ep_zahtev_za_taxi_kartice.pdf">EP zahtev za Taksi kartice.pdf</a>)
                    </li>

                    <li class="mb-3">
                        <b>Popunite pristupnicu.</b>
                        Zaposleni na BS će rado pomoći oko svih potrebnih informacija i načina popunjavanja pristupnice.
                    </li>

                    <li class="mb-3">
                        <b>Pošaljete potrebnu dokumentaciju</b>
                        na adresu: DOO Euro Petrol, Senćanski put 75, 24000 Subotica, PAK 24107 (Odeljenje za izradu kartica)  ili je predate na EP benzinskoj stanici.
                    </li>
                </ul>

                <p class="mb-5">
                    <i>Za detaljne informacije možete pozvati besplatnu info liniju 0800177 777 ili  call centar  024 664 664.</i>
                </p>

                <h3 class="fw-bold mb-3 color-main">Ko može postati korisnik Taksi kartice?</h3>

                <p>
                    Korisnik Taksi kartice može da postane svako lice koje vrši uslugu taksi prevoza, samostalno ili kod drugog preduzetnika/pravnog lica, a koje poseduje važeću dozvolu za pružanje usluga taksi prevoza izdatu od strane nadležnog organa i koje je korisnik vozila koje je u skladu sa propisima Republike Srbije označeno kao taxi vozilo (registarska oznaka TX).
                </p>

                <p class="mb-5">
                    Taksi kartice su kartice na registarsku oznaku vozila.
                </p>

                <h3 class="fw-bold mb-3 color-main">Za koliko dana stiže Taksi kartica?</h3>

                <p class="mb-5">
                    Taksi KARTICA stiže najkasnije za 5 radnih dana, na kućnu adresu, odnosno na adresu navedenu u pristupnici.
                </p>

                <h3 class="fw-bold mb-3 color-main">Da li se Taksi kartica naplaćuje?</h3>

                <p class="mb-5">
                    Kartica je besplatna, glasi na ime i nije prenosiva. TAKSI KARTICA je sredstvo za ostvarivanje prava na popust i ne može biti prihvaćena kao sredstvo plaćanja za robu. Odnosi se samo na gotovinsko plaćanje.
                </p>

            </div>
            <!-- Pravna lica -->
            <div class="tab-pane fade p-4" id="pravna-lica" role="tabpanel" aria-labelledby="pravna-lica-tab">
                <img
                    class="img-fluid col-xl-2 col-lg-3 col-md-4 col-6"
                    src="/img/epk/epk_card_4.webp"
                    srcset="
                        /img/epk/epk_card_4@2x.webp 2x,
                        /img/epk/epk_card_4@3x.webp 3x
                    "
                    alt="Kartica za pravne lice"
                />

                <h3 class="fw-bold my-3 color-main">Šta obezbeđuje Korporativna kartica?</h3>

                <ul class="mb-5">
                    <li class="mb-3">
                        <b>Stimulativne popuste</b>
                    </li>

                    <li class="mb-3">
                        <b>Online</b> uvid i kontrolu troškova goriva (po vozilu, vozaču, periodu)
                    </li>

                    <li class="mb-3">
                        <b>Zbirni računi</b> i pojednostavljeno knjigovodstvo
                    </li>

                    <li class="mb-3">
                        Mogućnost <b>avansnog i odloženog plaćanja</b> i <b>limitiranja</b> po kartici/mesecu
                    </li>

                    <li class="mb-3">
                        <b>PIN zaštita</b> svake kartice
                    </li>

                    <li class="mb-3">
                        Odvojen <b>putnički</b> i <b>teretni</b> program
                    </li>
                </ul>

                <h3 class="fw-bold mb-3 color-main">Ko može postati korisnik Korporativne kartice?</h3>

                <p class="mb-5">Pravno lice koje ima registrovanu kompaniju.</p>

                <h3 class="fw-bold mb-3 color-main">Za koliko dana stiže Korporativna kartica?</h3>

                <p class="mb-5">
                    Kartica stiže najkasnije u roku od <b>7 radnih dana</b> na adresu koju navedete ili na izabranu Euro Petrol stanicu.
                </p>

                <h3 class="fw-bold mb-3 color-main">Da li se Korporativna kartica naplaćuje?</h3>

                <ul>
                    <li class="mb-3">Kartica se izdaje <b>jednostavno i besplatno</b></li>

                    <li class="mb-3"><b>Bez</b> mesečnih troškova održavanja</li>

                    <li class="mb-3"><b>Bez</b> minimalne mesečne potrošnje</li>

                    <li class="mb-3"><b>Bez</b> polaganja depozita</li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
import AlternativeHeader from "../components/UI/AlternativeHeader.vue";

export default {
    data: function() {
        return {
            isOpen: false
        };
    },
    components: {
        AlternativeHeader
    },
    mounted() {
        this.goToTab();
    },
    methods: {
        goToTab() {
            var parts = window.location.href.split('#');
            if (parts.length > 1) {
                var tab = parts[1];
                if (this.$refs[tab]) this.$refs[tab].click();
            }
        }
    }
}

</script>

<style scoped>
.section-title{
    text-transform: initial;
}

.bg-black-20{
    background-color: var(--color-main);
}

#epk-switcher .active{
    color: var(--color-main) !important;
    font-weight: bold;
}

.mw-47rem{
    max-width: 47em;
}

.modal-custom {
  width: 50%;
  height: 80%;
  margin: 0px auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px 3px;
  transition: all 0.2s ease-in;
  font-family: Helvetica, Arial, sans-serif;
  overflow-y: auto;
  touch-action: pan-y !important;
}
.fadeIn-enter {
  opacity: 0;
}

.fadeIn-leave-active {
  opacity: 0;
  transition: all 0.2s step-end;
}

.fadeIn-enter .modal,
.fadeIn-leave-active.modal {
  transform: scale(1.1);
}

.overlay-modal {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #00000094;
  z-index: 999;
  transition: opacity 0.2s ease;
}

@media (max-width: 900px) {
  .modal-custom{
    width: 100%;
    height: 70%;
  }
}

</style>
